<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Inversionistas del Programa - {{ groups[0].program.name }}</h3>
				<div class="card-tools" v-if="groups[0].program.program_type_id == 1">
					<button class="btn btn-outline-success btn-sm mr-2" @click="exportData()" v-if="type==1">
						<i class="fa fa-file-excel"></i> Exportar
					</button>
					<button class="btn btn-outline-success btn-sm mr-2" @click="exportDataList()" v-if="type==2">
						<i class="fa fa-file-excel"></i> Exportar
					</button>
				</div>
			</div>

			<div class="card-body">

				<div v-if="loading" class="text-center">
					<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
					<h5>Cargando...</h5>
				</div>

				<!-- Indefinido -->
				<div v-else-if="groups[0].program.program_type_id == 2">
					<ListIndefinite />
				</div>

				<!-- Definido -->
				<div v-else>

					<div v-if="groups.length === 0" class="alert alert-warning">
						No hay grupos configurados en este programa.
					</div>

					<!--  -->
					<div class="card card-primary card-tabs">
						<div class="card-header p-0 pt-1">
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" id="custom-tabs-one-home-tab" data-toggle="pill" @click="type=1"
										href="#custom-tabs-one-home" role="tab" aria-controls="custom-tabs-one-home"
										aria-selected="true">Reporte por grupo</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="pill"  @click="type=2"
										href="#custom-tabs-one-profile" role="tab"
										aria-controls="custom-tabs-one-profile" aria-selected="false">Reporte
										general</a>
								</li>
							</ul>
						</div>
						<div class="card-body bd">
							<div class="tab-content" id="custom-tabs-one-tabContent">
								<div class="tab-pane fade show active" id="custom-tabs-one-home" role="tabpanel"
									aria-labelledby="custom-tabs-one-home-tab">

									<div class="row">
										<!-- GRUPOS -->
										<div v-for="group in groups" :key="group.id" class="mb-4 table-responsive">

											<div class="col-12"
												style="background-color: #7c8fb9; color: white; padding: 10px;">
												<h5 class="mb-0">Grupo {{ group.name }}
													<strong>Grupo {{ group.name }}</strong>
												</h5>
											</div>


											<table class="table table-bordered text-center">
												<thead>
													<tr>
														<th>Inversionista</th>
														<th>%</th>
														<th v-for="h in group.headers" :key="h.key">
															{{ h.label }}
															<br>
															{{ h.due_date | toDateTime }}
															<button class="btn btn-sm btn-outline-info m-1"
																@click="downloadProgramGroup(h.id, h.type, group.id)">
																<i class="fa fa-file-pdf"></i> Notificación
															</button>
															<hr>
															<small>Esperado / Pagado</small>
														</th>
														<th>Total pagado</th>
														<th>Pendiente</th>
														<th>% avance / Total</th>
														<th>Opciones</th>
													</tr>
												</thead>

												<tbody v-if="group.users.length > 0">
													<tr v-for="u in group.users" :key="u.id">
														<td>
															{{ u.name }}
															{{ u.last_name }}
															<!-- <hr>
										{{ u.company.name }} -->
														</td>
														<td>{{ u.percentage }}%</td>
														<td v-for="h in group.headers" :key="h.key"
															:class="getStatusClass(u.contributions[h.key])">
															<small v-if="u.contributions[h.key] > 0"
																class="text-success">
																{{ u.contributions[h.key].expected | toCurrency }}
																-
																<span
																	:class="u.contributions[h.key].paid > 0 ? 'text-success' : ''">
																	{{ u.contributions[h.key].paid | toCurrency }}
																</span>
																<hr>
																{{ u.contributions[h.key].pending | toCurrency }}
															</small>
															<small v-else>
																{{ u.contributions[h.key].expected | toCurrency }}
																-
																<span
																	:class="u.contributions[h.key].paid > 0 ? 'text-success' : ''">
																	{{ u.contributions[h.key].paid | toCurrency }}
																</span>
																<hr>
																{{ u.contributions[h.key].pending | toCurrency }}
															</small>
														</td>

														<td>{{ u.total_paid | toCurrency }}</td>
														<td>{{ u.pending | toCurrency }}</td>
														<td>
															<div class="progress" style="height: 12px;">
																<div class="progress-bar bg-success" role="progressbar"
																	:style="{ width: u.advance + '%' }">
																</div>
															</div>
															<small>{{ u.advance }}%</small>
															<br>-<br>
															<small>{{ u.total_expected | toCurrency }}</small>
														</td>
														<td>
															<!-- Botón para agregar aportación -->
															<button class="btn btn-sm btn-outline-success m-1"
																v-can="'add_programs_investors'"
																@click="openContributionModal(group.id, u.id, u.company_id)">
																<i class="fa-solid fa-plus"></i> Aportar
															</button>

															<!-- Botón historial -->
															<button class="btn btn-sm btn-outline-secondary m-1"
																@click="openHistoryModal(group.id, u.id, u.company_id, u)">
																<i class="fa-solid fa-clock-rotate-left"></i> Historial
															</button>

															<button class="btn btn-sm btn-outline-info m1"
																@click="downloadProgramInvestore(group.id, u.id, u.company_id)">
																<i class="fa fa-file-excel"></i> Exportar
															</button>

														</td>
													</tr>
													<tr class="bg-light font-weight-bold">
														<td colspan="2">Totales Grupo</td>

														<td v-for="h in group.headers" :key="'total-' + h.key">
															<small>
																{{ getColumnTotal(group, h.key, 'expected') | toCurrency
																}}
																-
																<span class="text-success">
																	{{ getColumnTotal(group, h.key, 'paid') | toCurrency
																	}}
																</span>
																<hr>
																{{ getColumnTotal(group, h.key, 'pending') | toCurrency
																}}
															</small>
														</td>

														<td>
															{{ getGroupTotal(group, 'total_paid') | toCurrency }}
														</td>

														<td>
															{{ getGroupTotal(group, 'pending') | toCurrency }}
														</td>

														<td colspan="2"></td>
													</tr>
												</tbody>

												<tbody v-else>
													<tr>
														<td colspan="4">Sin inversionistas asignados</td>
													</tr>
												</tbody>

											</table>
										</div>
									</div>

								</div>
								<div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel"
									aria-labelledby="custom-tabs-one-profile-tab">

									<div class="row">
										<table class="table table-bordered table-sm">
											<thead>
												<tr>
													<th>ID</th>
													<th>Fecha</th>
													<th>Usuario</th>
													<th>Empresa</th>
													<th>Tipo pago</th>
													<th>Monto</th>
													<th>Aportaciones cubiertas</th>
													<th>Enviado</th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="row in rows" :key="row.id">
													<td>{{ row.folio }}</td>
													<td>{{ row.date | toDateTime }}</td>
													<td>
														{{ row.user.name }} <br>
													</td>
													<td>{{ row.company.name }}</td>
													<td>{{ row.type_payment.name }}</td>
													<td>{{ row.amount | toCurrency }}</td>
													<td>
														<div v-for="detail in row.details" :key="detail.detail_id">
															<small>
																{{ detail.installment_label }}:
																{{ detail.paid_amount | toCurrency }}
															</small>
														</div>
													</td>
													<td>{{ row.send_label }}</td>
												</tr>

												<tr v-if="rows.length === 0">
													<td colspan="12" class="text-center">
														No hay pagos registrados.
													</td>
												</tr>
											</tbody>

											<tfoot v-if="rows.length > 0">
												<tr>
													<th colspan="5" class="text-right">Total</th>
													<th>{{ totals.amount | toCurrency }}</th>
													<th colspan="2"></th>
												</tr>
											</tfoot>
										</table>

									</div>

								</div>

							</div>
						</div>
					</div>

					<!--  -->


				</div>

			</div>
		</div>

		<!-- Modal de aportación -->
		<ModalProgramGroupContribution />

		<!-- Modal historial (opcional) -->
		<ModalProgramGroupContributionHistory />

		<ModalFormVoucherContribution />
	</div>
</template>

<script>
import request from "@/services/request";
import { mapActions } from "vuex";

import ModalProgramGroupContribution from "@/components/programs/investors/ModalProgramGroupContribution.vue";
import ModalProgramGroupContributionHistory from "@/components/programs/investors/ModalProgramGroupContributionHistory.vue";
import ListIndefinite from "@/components/programs/indefinite/ListComponent.vue";
import ModalFormVoucherContribution from '@/components/programs/ModalFormVoucherContribution.vue';

export default {
	name: 'programs-investors-table',
	components: {
		ModalProgramGroupContribution,
		ModalProgramGroupContributionHistory,
		ListIndefinite,
		ModalFormVoucherContribution
	},

	data() {
		return {
			loading: true,
			program_id: "",
			groups: [],
			rows: [],
			type:1,
			totals: {
				payments_count: 0,
				amount: 0
			}

		};
	},

	methods: {
		async getPagosDefinido(programId) {

			try {
				let { data } = await request.get(`/programs/${programId}/pagos-definido/json`);
				console.log(data);
				this.rows = data.rows;
				this.totals = data.totals;
			} catch (error) {
				console.error(error);

			}
		},

		downloadProgramGroup(header_id, header_type, group_id) {
			let filter = this.globalUrlFiles + `/aportaciones/reporte/${header_id}/${header_type}/${group_id}`;
			window.open(filter, '_blank');
		},
		getStatusClass(contribution) {
			if (!contribution) return ''

			const { expected, paid } = contribution

			if (paid >= expected) {
				return 'bg-pay'
			}

			if (paid > 0) {
				return 'bg-partial'
			}

			return ''
		},
		exportData() {
			let filter = this.globalUrlFiles + `/programs/${this.program_id}/investors/export`;
			window.open(filter, '_blank');
		},
		exportDataList() {
			let filter = this.globalUrlFiles + `/programs/${this.program_id}/pagos-definido/excel`;
			window.open(filter, '_blank');
		},
		downloadProgramInvestore(grupo_id, user_id, company_id) {
			let filter = this.globalUrlFiles + `/program-groups/${grupo_id}/users/${user_id}/companies/${company_id}/payments/export`;
			window.open(filter, '_blank');
		},
		getColumnTotal(group, key, field) {
			return group.users.reduce((sum, user) => {
				if (user.contributions[key]) {
					return sum + Number(user.contributions[key][field] || 0);
				}
				return sum;
			}, 0);
		},

		getGroupTotal(group, field) {
			return group.users.reduce((sum, user) => {
				return sum + Number(user[field] || 0);
			}, 0);
		},
		async loadInvestors() {
			this.loading = true;

			try {
				let { data } = await request.get(`/programs/${this.program_id}/investors`);
				this.groups = data;
				this.getPagosDefinido(this.program_id);
			} catch (error) {
				console.log(error);
			}

			this.loading = false;
		},

		openContributionModal(group_id, user_id, company_id) {
			let companies_ids = this.groups[0].companies.map(c => c.id);
			Event.$emit("event-open-program-group-contribution", {
				program_id: this.program_id,
				program_group_id: group_id,
				user_id: user_id,
				company_id: company_id,
				companies_id: companies_ids
			});
		},

		openHistoryModal(group_id, user_id, company_id, user) {
			console.log(user);
			Event.$emit("event-open-program-group-contribution-history", {
				program_group_id: group_id,
				user_id: user_id,
				company_id: company_id,
				user_name: user.name + ' ' + user.last_name + ' / ' + user.company.name,
				user_email: user.email
			});
		},

		...mapActions({
			errorNotification: "alert/error",
			successNotification: "alert/success",
		})
	},

	mounted() {
		this.program_id = this.$route.params.id;
		this.loadInvestors();


		Event.$on("event-reload-program-relations", () => {
			this.loadInvestors();
		});
	}
};
</script>

<style scoped>
.progress {
	background-color: #e9ecef;
}

.progress-bar {
	transition: width 0.5s;
}

.bg-pay {
	background-color: #C6E0B4 !important;
}

.bg-partial {
	background-color: #FFE699 !important;
}

.bg-pending {
	background-color: #F8CBAD;
}

.card-primary:not(.card-outline)>.card-header {
	background-color: #224c83;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	color: #ffffff !important;
	background-color: #859dcd;
	border-color: #dee2e6 #dee2e6 #fff;
}
.bd{
	border: 1px solid #dcdcdc;
    border-radius: 0px 0px 10px 10px;
}
</style>
